import POKA1ResultView from "./POKA1ResultView";
import POKA2ResultView from "./POKA2ResultView";
import POKA3ResultView from "./POKA3ResultView";
import PSKA1ResultView from "./PSKA1ResultView";

export default {
    POKA1: POKA1ResultView,
    POKA2: POKA2ResultView,
    POKA3: POKA3ResultView,
    PSKA1: PSKA1ResultView,
};
